<template>
  <form element-loading-background="rgba(0, 0, 0, 0.2)" v-loading="loading" @submit.prevent="">
    <div>
      <div class="login_panel">
        <div class="login_title">
          <span>系统登录</span>
        </div>

        <div class="mgt-30 form_item_container">
          <div class="lh-24 flex_row txt-white ai-c">
            <span class="fs-14">账号绑定手机号码：</span>
            <span class="fs-20 bold">{{ formObject.phone | hidePhone }}</span>
          </div>
        </div>

        <div class="mgt-30 form_item_container relative">
          <el-input
            placeholder="输入验证码"
            v-model="formObject.vertfiyCode"
            maxlength="6"
            :disabled="disable"
            class="code">
            <i slot="prefix" class="el-input__icon el-icon-lock form_item_icon"></i>
            <img class="" src="" alt="">
          </el-input>
          <el-button class="send-code" size="small" round disabled v-if="time">{{ time }}秒后重新获取</el-button>
          <el-button class="send-code" size="small" round @click="sendCode" v-else>发送短信</el-button>
        </div>

        <div class="mgt-30">
          <button class="el-button login_btn el-button--primary" type="submit" @click="login">
            登 录
          </button>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import {mapActions} from "vuex";

export default {
  name: "Verify"
  , data() {
    return {
      loading: false
      , time: 0
      , timer: null
      , disable: true
      , formObject: {
        vertfiyCode: ""
        , phone: ""
        , tmpAccessToken: ""
      }
    }
  }
  , computed: {}
  , methods: {
    ...mapActions(["getPhoneCode", "verifyLogin"])
    , login() {
      this.loading = true
      this.verifyLogin(this.formObject).then(() => {
        location.href = "/";
      }).finally(() => {
        this.loading = false
      })
    }
    , timeout() {
      if (this.time === 0) return
      this.timer = setTimeout(() => {
        --this.time;
        this.timeout()
      }, 1000)
    }
    , sendCode() {
      this.getPhoneCode(this.formObject).then(result => {
        this.time = result.sms_expired_minutes * 60
        this.disable = false
        this.timeout()
      })
    }
    , hidePhone(phone) {
      if (!/^1[0-9]{10}$/.test(phone)) throw new Error(`无效的手机号码！${phone}`)
      return phone
    }
  }
  , created() {
    let {tmpAccessToken, phone} = this.$route.params
    this.formObject.phone = this.hidePhone(phone)
    this.formObject.tmpAccessToken = tmpAccessToken
  }

}
</script>

<style lang="scss" scoped>
.send-code {
  position: absolute;

  right: 10px;
  top: 10px;
}
</style>
